import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useEffect, useRef } from 'react';
import ErrorDisplay from './ErrorDisplay';
import useDidMount from '../../hooks/useDidMount';
const InputPicker = ({ name, type, value, step, inputIsValid, errorText, onBlur, onChange, placeholder, inputLabel, titleClass, required, tabindex, focus, }) => {
    const isMounted = useDidMount();
    const inputRef = useRef(false);
    const defaultClass = 'block w-full py-3 px-4 mb-3 rounded transition hover:bg-gray-300 focus:outline-none focus:bg-white focus:border-2 text-gray-600 focus:text-black';
    const inputClass = inputIsValid
        ? defaultClass + ' form-field-valid'
        : defaultClass + ' form-field-invalid';
    let minValue = type === 'number' ? '0' : '';
    useEffect(() => {
        if (isMounted === true) {
            inputRef.current.focus();
        }
    }, [focus]);
    return (_jsxs(Fragment, { children: [_jsxs("label", { className: titleClass
                    ? `${titleClass}`
                    : 'mb-2 block text-sm font-bold uppercase tracking-wide text-gray-700', htmlFor: name, children: [inputLabel, required ? _jsx("span", { className: "px-1 text-sm text-red-500", children: "*" }) : null] }), _jsx("div", { children: _jsx("input", { autoComplete: "off", className: inputClass, id: name, min: minValue, name: name, onBlur: onBlur, onChange: onChange, placeholder: placeholder, ref: inputRef, step: step, tabIndex: tabindex, type: type, value: value }) }), _jsx(ErrorDisplay, { errorText: errorText, isValid: inputIsValid })] }));
};
export default InputPicker;
